'use client';

import { useEffect, useRef, useState } from 'react';

import { Locales, themes } from '@monoimin/sb-types';
import { useLocale } from '@monoimin/intl';

import SpoilerButtonView from './SpoilerButtonView';

export interface NewSpoilerButtonProps {
  titles?: {
    opened?: string;
    closed?: string;
  };
  theme?: themes;
  className?: string | Record<string, any>;
}
const showMoreText: Record<Locales, string> = {
  en: 'Show More',
  de: 'Mehr anzeigen',
  ru: 'Показать больше',
  tr: 'Daha fazla göster',
};

const showLessText: Record<Locales, string> = {
  en: 'Show Less',
  de: 'Weniger anzeigen',
  ru: 'Показать меньше',
  tr: 'Daha az göster',
};

const ClientButton = ({
  titles: customTitles,
  theme,
  className,
}: NewSpoilerButtonProps) => {
  const ref = useRef<HTMLButtonElement>(null);
  const [isOpen, setIsOpen] = useState(false);
  const locale = useLocale();
  const titles = {
    closed: showMoreText[locale],
    opened: showLessText[locale],
    ...customTitles,
  };
  useEffect(() => {
    if (!ref.current) return;
    const parent = ref.current.parentElement;

    if (!parent || parent.dataset.listenerLoaded) return;
    const button = ref.current;
    ref.current.onclick = () => {
      const isExpanded = parent.dataset.expanded === 'true';
      parent.dataset.expanded = isExpanded ? 'false' : 'true';
      const contentElement = parent.querySelector('.text-spoiler-content');
      const contentHeight = contentElement?.scrollHeight;
      const viewHeight = window.innerHeight;

      if (isExpanded && contentHeight && contentHeight > viewHeight) {
        window.scrollTo({
          top: parseInt(button.dataset.prevOffset || '0'),
          behavior: 'smooth',
        });
      }

      setIsOpen(!isExpanded);
      button.dataset.expanded = parent.dataset.expanded;
      if (!isExpanded) {
        button.dataset.prevOffset = window.scrollY.toString();
      }
      const buttonText = button.querySelector('[data-button-text="true"]');
      if (buttonText) {
        buttonText.textContent =
          (isExpanded ? titles?.['closed'] : titles?.['opened']) || null;
      }
    };

    parent.dataset.listenerLoaded = 'true';
  }, [ref.current]);

  return (
    <SpoilerButtonView
      buttonRef={ref}
      isOpen={isOpen}
      buttonTitle={titles?.['closed']}
      theme={theme}
      className={className}
    />
  );
};

export default ClientButton;
